// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__1h2JW","rootSuccess":"CompleteLink_rootSuccess__1OMkU","rootFailure":"CompleteLink_rootFailure__hucH3","isDisabled":"CompleteLink_isDisabled__daxO1"};